tinymce.Resource.add('tinymce.html-i18n.help-keynav.es',
'<h1>Iniciar la navegación con el teclado</h1>\n' +
  '\n' +
  '<dl>\n' +
  '  <dt>Enfocar la barra de menús</dt>\n' +
  '  <dd>Windows o Linux: Alt+F9</dd>\n' +
  '  <dd>macOS: &#x2325;F9</dd>\n' +
  '  <dt>Enfocar la barra de herramientas</dt>\n' +
  '  <dd>Windows o Linux: Alt+F10</dd>\n' +
  '  <dd>macOS: &#x2325;F10</dd>\n' +
  '  <dt>Enfocar el pie de página</dt>\n' +
  '  <dd>Windows o Linux: Alt+F11</dd>\n' +
  '  <dd>macOS: &#x2325;F11</dd>\n' +
  '  <dt>Enfocar la notificación</dt>\n' +
  '  <dd>Windows o Linux: Alt+F12</dd>\n' +
  '  <dd>macOS: &#x2325;F12</dd>\n' +
  '  <dt>Enfocar una barra de herramientas contextual</dt>\n' +
  '  <dd>Windows, Linux o macOS: Ctrl+F9</dd>\n' +
  '</dl>\n' +
  '\n' +
  '<p>La navegación comenzará por el primer elemento de la interfaz de usuario (IU), de tal manera que se resaltará, o bien se subrayará si se trata del primer elemento de\n' +
  '  la ruta de elemento del pie de página.</p>\n' +
  '\n' +
  '<h1>Navegar entre las secciones de la IU</h1>\n' +
  '\n' +
  '<p>Para pasar de una sección de la IU a la siguiente, pulse la tecla <strong>Tab</strong>.</p>\n' +
  '\n' +
  '<p>Para pasar de una sección de la IU a la anterior, pulse <strong>Mayús+Tab</strong>.</p>\n' +
  '\n' +
  '<p>El orden de <strong>tabulación</strong> de estas secciones de la IU es:</p>\n' +
  '\n' +
  '<ol>\n' +
  '  <li>Barra de menús</li>\n' +
  '  <li>Cada grupo de barra de herramientas</li>\n' +
  '  <li>Barra lateral</li>\n' +
  '  <li>Ruta del elemento en el pie de página</li>\n' +
  '  <li>Botón de alternancia de recuento de palabras en el pie de página</li>\n' +
  '  <li>Enlace de personalización de marca en el pie de página</li>\n' +
  '  <li>Controlador de cambio de tamaño en el pie de página</li>\n' +
  '</ol>\n' +
  '\n' +
  '<p>Si una sección de la IU no está presente, esta se omite.</p>\n' +
  '\n' +
  '<p>Si el pie de página tiene un enfoque de navegación con el teclado y no hay ninguna barra lateral visible, al pulsar <strong>Mayús+Tab</strong>,\n' +
  '  el enfoque se moverá al primer grupo de barra de herramientas, en lugar de al último.</p>\n' +
  '\n' +
  '<h1>Navegar dentro de las secciones de la IU</h1>\n' +
  '\n' +
  '<p>Para pasar de un elemento de la IU al siguiente, pulse la tecla de <strong>flecha</strong> correspondiente.</p>\n' +
  '\n' +
  '<p>Las teclas de flecha <strong>izquierda</strong> y <strong>derecha</strong> permiten</p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>desplazarse entre los menús de la barra de menús.</li>\n' +
  '  <li>abrir el submenú de un menú.</li>\n' +
  '  <li>desplazarse entre los botones de un grupo de barra de herramientas.</li>\n' +
  '  <li>desplazarse entre los elementos de la ruta de elemento del pie de página.</li>\n' +
  '</ul>\n' +
  '\n' +
  '<p>Las teclas de flecha <strong>abajo</strong> y <strong>arriba</strong> permiten</p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>desplazarse entre los elementos de menú de un menú.</li>\n' +
  '  <li>desplazarse entre los elementos de un menú emergente de una barra de herramientas.</li>\n' +
  '</ul>\n' +
  '\n' +
  '<p>Las teclas de <strong>flecha</strong> van cambiando dentro de la sección de la IU enfocada.</p>\n' +
  '\n' +
  '<p>Para cerrar un menú, un submenú o un menú emergente que estén abiertos, pulse la tecla <strong>Esc</strong>.</p>\n' +
  '\n' +
  '<p>Si el enfoque actual se encuentra en la parte superior de una sección de la IU determinada, al pulsar la tecla <strong>Esc</strong> saldrá\n' +
  '  de la navegación con el teclado por completo.</p>\n' +
  '\n' +
  '<h1>Ejecutar un elemento de menú o un botón de barra de herramientas</h1>\n' +
  '\n' +
  '<p>Si el elemento de menú o el botón de barra de herramientas deseado está resaltado, pulse la tecla <strong>Retorno</strong> o <strong>Entrar</strong>,\n' +
  '  o la <strong>barra espaciadora</strong> para ejecutar el elemento.</p>\n' +
  '\n' +
  '<h1>Navegar por cuadros de diálogo sin pestañas</h1>\n' +
  '\n' +
  '<p>En los cuadros de diálogo sin pestañas, el primer componente interactivo se enfoca al abrirse el cuadro de diálogo.</p>\n' +
  '\n' +
  '<p>Para navegar entre los componentes interactivos del cuadro de diálogo, pulse las teclas <strong>Tab</strong> o <strong>Mayús+Tab</strong>.</p>\n' +
  '\n' +
  '<h1>Navegar por cuadros de diálogo con pestañas</h1>\n' +
  '\n' +
  '<p>En los cuadros de diálogo con pestañas, el primer botón del menú de pestaña se enfoca al abrirse el cuadro de diálogo.</p>\n' +
  '\n' +
  '<p>Para navegar entre componentes interactivos de esta pestaña del cuadro de diálogo, pulse las teclas <strong>Tab</strong> o\n' +
  '  <strong>Mayús+Tab</strong>.</p>\n' +
  '\n' +
  '<p>Si desea cambiar a otra pestaña del cuadro de diálogo, enfoque el menú de pestañas y, a continuación, pulse la tecla de <strong>flecha</strong>\n' +
  '  correspondiente para moverse por las pestañas disponibles.</p>\n');